import ItemService from './ItemService'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { allCommande } from '../../../../commons/redux/actions/user.actions'
import { Spinner } from '@chakra-ui/react'

export default function ServicesDemand() {
  const dispatch = useDispatch()
  const token = localStorage.getItem('token')
  const data = useSelector((state) => state.adminReducer)
  const [item, setItem] = useState(false)
  const [load, setLoad] = useState(false)
  console.log(data)
  useEffect(() => {
    dispatch(allCommande(token))
  }, [token, dispatch])
  useEffect(() => {
    setItem(data.item)
  }, [data.item])

  
  return (
    <div>
      <div className="bg-gray-50 pt-10">
        <div className=" col-lg-8 mx-auto bg-white">
          {' '}
          <div className="p-3 flex">
            <h2 className="text-2xl font-bold"> Service a la demande</h2>
            <p className="bg-gray-100 rounded-full text-center font-bold h-10 w-10 p-1 text-xl">
              {' '}
              {data?.item ? data?.item?.length : '0'}
            </p>

            <div className="ml-auto">
              <select name="" id="" className="form-select">
                <option value="">
                  Trier pour :
                </option>
                <option value="libreville">Libreville</option>
                <option value="Dakar">Dakar</option>
              </select>
            </div>
          </div>
          <div className="flex flex-wrap">
            {!item ? (
              <div className="mx-auto text-center">
                <Spinner
                  thickness="4px"
                  speed="0.65s"
                  emptyColor="gray.200"
                  color="blue.500"
                  size="xl"
                />{' '}
              </div>
            ) : item.length > 0 ? (
              <>
                {Array.from(data?.item).map((value, index) => {
                  return <ItemService {...value} />
                })}
              </>
            ) : (
              <div className="flex justify-center mt-30 min-h-screen text-center text-gray-400 text-4xl font-bold opacity-2">
                <h3>Vous n'avez pas encore de service a la demande</h3>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
